/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Container from '../Container/Container';
import "./Image.css";
export default function Image(props) {
  var _props$bg = props.bg,
      bg = _props$bg === void 0 ? 'transparent' : _props$bg,
      children = props.children;
  var imgProps = {
    src: null,
    srcSet: '',
    alt: null
  };
  var otherChildren = [];
  React.Children.forEach(children, function (child, i) {
    // Images are always expected to be parsed in a wrapping div.
    if (i === 0) {
      var counter = 1;
      React.Children.forEach(child.props.children, function (grandChild) {
        if (grandChild.type === 'img') {
          if (counter === 1) {
            imgProps.src = grandChild.props.src;
            imgProps.alt = grandChild.props.alt;
          }

          imgProps.srcSet += "" + (counter > 1 ? ', ' : '') + grandChild.props.src + " " + counter++ + "x";
        } else {
          otherChildren.push(grandChild);
        }
      });
    } else {
      otherChildren.push(child);
    }
  });
  var childNodes = /*#__PURE__*/React.createElement(React.Fragment, null, imgProps.src && /*#__PURE__*/React.createElement("div", {
    className: "Image Image--" + bg
  }, /*#__PURE__*/React.createElement("img", imgProps)), otherChildren);

  if (typeof props.do !== 'undefined') {
    return /*#__PURE__*/React.createElement(Container, {
      border: true,
      do: true
    }, ' ', childNodes, ' ');
  } else if (typeof props.dont !== 'undefined') {
    return /*#__PURE__*/React.createElement(Container, {
      border: true,
      dont: true
    }, ' ', childNodes, ' ');
  }

  return /*#__PURE__*/React.createElement(Container, {
    border: true
  }, " ", childNodes, " ");
}
//# sourceMappingURL=Image.js.map